module.exports = __webpack_public_path__ + "img/french_narrator.3b26a28b.jpg";